module.exports = __webpack_public_path__ + "img/level_hight.59d2b9b7.png";